<template>
  <a :href="emailContent">
    <slot />
  </a>
</template>

<script>
export default {
  name: 'BaseEmail',
  props: {
    address: {
      type: String,
      required: true,
    },
    ccList: {
      type: Array,
      default: () => [],
    },
    bccList: {
      type: Array,
      default: () => [],
    },
    subject: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
  },
  computed: {
    emailContent() {
      let emailContent = `mailto:${this.address}?`;

      if (this.ccList.length) {
        emailContent += `&cc=${this.ccList.join(', ')}`;
      }

      if (this.bccList.length) {
        emailContent += `&bcc=${this.bccList.join(', ')}`;
      }

      if (this.subject) {
        const formatedSubject = encodeURIComponent(this.subject);

        emailContent += `&subject=${formatedSubject}`;
      }

      if (this.body) {
        const formatedbody = encodeURIComponent(this.body);

        emailContent += `&body=${formatedbody}`;
      }

      return emailContent;
    },
  },
};
</script>
